/* eslint-disable */

import $ from 'jquery'
import d3 from './d3-3'
import purpleDots from './assets/dots_purple.svg'
import { generateUUID } from '../../../../../utils'

export function DonutChart() {
  var palette

  // Available color palettes
  this.palettes = {
    purple: {
      outline: '#7455FF',
      gradient: {
        start: '#e040fb',
        stop: '#7455ff'
      },
      dotFill: '#E148FB'
    },
    green: {
      outline: '#A9EFC2',
      gradient: {
        start: '#A9EFC2',
        stop: '#957EEF'
      },
      dotFill: '#9F85ED'
    },
    orange: {
      outline: '#FF8874',
      gradient: {
        start: '#FF8874',
        stop: '#BAECDE'
      },
      dotFill: '#BEE5D7'
    }
  }

  var key = function (d) {
    return generateUUID()
  }

  this.create = function (settings) {

    this.path = '../assets/charts/'

    this.parent = d3.select('#' + settings.el)
    this.margin = settings.margin
    this.paletteName = settings.palette
    this.palette = this.palettes[settings.palette]
    this.hasIcons = settings.hasIcons
    this.icons = settings.icons
    this.divId = settings.el

    this.svgIcons = []

    palette = this.palette
    this.svg = d3
      .select('#' + this.divId)
      .classed('donutChart', true)
      .append('svg')
      .append('g')

    this.svg.append('g').attr('class', 'slices')
    this.svg.append('g').attr('class', 'labels')
    this.svg.append('g').attr('class', 'legends')
    this.svg.append('g').attr('class', 'values')
    this.svg.append('g').attr('class', 'lines')
    this.svg.append('g').attr('class', 'circles')
    this.svg.append('g').attr('class', 'icons')

    this.svg
      .append('text')
      .attr('class', 'centerValue')
      .attr('x', 0)
      .attr('y', 0)
      .attr('fill', '#000')
      .attr('text-anchor', 'middle')
      .attr('font-family', 'GT-America-Thin')
      .attr('font-size', '50px')
      .text(' ') /*empty placeholder*/

    this.svg
      .append('text')
      .attr('class', 'centerLabel')
      .attr('x', 0)
      .attr('y', 40)
      .attr('fill', '#000')
      .attr('text-anchor', 'middle')
      .attr('font-family', 'GT-America-Thin')
      .attr('font-size', '25px')
      .text(' ') /*empty placeholder*/

    this.pie = d3.layout
      .pie()
      .sort(null)
      .value(function (d) {
        return d.value
      })

    var bbox = this.parent.node().getBoundingClientRect()
    this.width = bbox.width - this.margin.left - this.margin.right
    this.height = bbox.height - this.margin.top - this.margin.bottom
    var radius = 0.3 * this.width

    this.arc = d3.svg
      .arc()
      .outerRadius(radius * 0.8)
      .innerRadius(radius * 0.65)

    this.outerArc = d3.svg
      .arc()
      .innerRadius(radius * 0.8)
      .outerRadius(radius * 0.9)

    this.svg.attr(
      'transform',
      'translate(' +
      (this.margin.left + this.width / 2) +
      ',' +
      (this.margin.top + this.height / 2) +
      ')'
    )

    // Gradient background
    var svgDefs = this.svg.append('defs')
    var gradient = svgDefs
      .append('linearGradient')
      .attr('id', this.divId + '_gradient')

    gradient
      .append('stop')
      .attr('class', 'left ' + this.paletteName)
      .attr('offset', '0')

    gradient
      .append('stop')
      .attr('class', 'right ' + this.paletteName)
      .attr('offset', '1')

    var that = this
    var promises = []

    //Load icons
    if (this.hasIcons === true) {
      $.each(this.icons, function (i, iconPath) {
        var def = new $.Deferred()
        var fullPath = that.path + '/images/' + iconPath
        d3.xml(fullPath)
          .mimeType('image/svg+xml')
          .get(function (error, xml) {
            if (error) {
              throw error
            } else {
              var node = document.importNode(
                xml.documentElement.getElementsByTagName('g')[0],
                true
              )
              that.svgIcons.push(node)
              def.resolve('resolved')
            }
          })
        promises.push(def)
      })
    }

    //Load dot background
    var def1 = new $.Deferred()
    d3.xml(purpleDots)
      .mimeType('image/svg+xml')
      .get(function (error, xml) {
        if (error) {
          throw error
        } else {
          var svgNode = xml.documentElement.getElementsByTagName('g')[2]
          svgNode.setAttribute('id', that.divId + '_dots')
          svgNode.setAttribute('class', 'purpodots')

          //DOM node
          that.svg.node().appendChild(svgNode)
          d3.select('#' + that.divId + '_dots').attr(
            'fill',
            that.palette.dotFill
          )

          def1.resolve('resolved')
        }
      })

    promises.push(def1)
    return $.when.apply(undefined, promises).promise()
  }

  this.update = function (data) {

    /* ------- CENTER LABEL (optional)-------*/

    if (data.centerValue) {
      if (data.centerValue.value)
        this.svg.select('.centerValue').text(data.centerValue.value)
      if (data.centerValue.label)
        this.svg.select('.centerLabel').text(data.centerValue.label)
    }

    /* ------- PIE SLICES -------*/
    this.svg.select('.slices').each(function () {
      this.parentNode.appendChild(this)
    })
    this.svg.select('.slices').moveToBack()
    d3.select('#' + this.divId + '_dots').moveToBack()``

    var slice = this.svg
      .select('.slices')
      .selectAll('path.slice')
      //pie(data) returns an array of objects representing each datum's arc angles
      .data(this.pie(data.chartData), key)
    // value - the numeric value of the arc.
    // index - the zero-based sorted index of the arc.
    // startAngle - the start angle of the arc.
    // endAngle - the end angle of the arc.
    // padAngle - the pad angle of the arc.

    var that = this
    slice
      .enter()
      .insert('path')
      .style('fill', function (d, i) {
        var fill
        switch (i) {
          case 0: //slice 0
            fill = '#fff'
            break
          case 1: //slice 1
            fill = 'none'
            break
          case 2: //slice 2
            fill = 'url(#' + that.divId + '_gradient)'

            break
          default:
            fill = '#000000'
            break
        }
        return fill
      })
      .style('stroke', function (d, i) {
        var stroke
        switch (i) {
          case 0: //slice 0
            stroke = palette.outline
            break
          case 1: //slice 1
            stroke = 'none'
            break
          case 2: //slice 2
            stroke = 'url(#' + that.divId + '_gradient)'
            break
          default:
            stroke = palette.outline
            break
        }
        return stroke
      })
      .style('z-index', '-100')
      .attr('id', function (d) {
        var id = 'slice_' + d.startAngle
        return id
      })
      .attr('class', 'slice')

    slice
      .transition()
      .duration(1000)
      .attrTween('d', function (d) {
        this._current = this._current || d
        var interpolate = d3.interpolate(this._current, d)
        this._current = interpolate(0)
        return function (t) {
          return that.arc(interpolate(t))
        }
      })
    slice.exit().remove()

    /* ------- ICONS -------*/
    if (this.hasIcons === true) {
      var icon = this.svg
        .selectAll('.icon')
        .data(this.pie(data.chartData), key)

      // var that = this
      icon
        .enter()
        .append('g')
        .attr('class', 'icon')
        .each(function (d, i) {
          if (that.svgIcons[i]) {
            this.appendChild(that.svgIcons[i].cloneNode(true))
          }
        })

      icon
        .transition()
        .duration(1000)
        .attrTween('transform', function (d) {
          this._current = this._current || d
          var interpolate = d3.interpolate(this._current, d)
          this._current = interpolate(0)
          return function (t) {
            var d2 = interpolate(t)
            var pos = that.outerArc.centroid(d2)
            var offset = midAngle(d2) < Math.PI ? -50 : 0
            pos[0] =
              offset + (that.width / 2) * (midAngle(d2) < Math.PI ? 1 : -1)
            pos[1] = pos[1] - 160
            return 'translate(' + pos + ')'
          }
        })

      icon.exit().remove()
    } else {
      /* ------- LEGENDS -------*/
      var text2 = this.svg
        .select('.legends')
        .selectAll('text')
        .data(this.pie(data.chartData), key)
      text2
        .enter()
        .append('text')
        .attr('dy', '-100px')
        .attr('fill', '#000')
        .attr('font-family', 'GT-America-Thin')
        .attr('font-size', '20px')
        .attr('class', 'text2')
        .text(function (d) {
          return d.data.legend
        })

      text2
        .transition()
        .duration(1000)
        .attrTween('transform', function (d) {
          this._current = this._current || d
          var interpolate = d3.interpolate(this._current, d)
          this._current = interpolate(0)
          return function (t) {
            var d2 = interpolate(t)
            var pos = that.outerArc.centroid(d2)
            pos[0] = midAngle(d2) < Math.PI ? that.width / 2 : -that.width / 2
            return 'translate(' + pos + ')'
          }
        })
        .styleTween('text-anchor', function (d) {
          this._current = this._current || d
          var interpolate = d3.interpolate(this._current, d)
          this._current = interpolate(0)
          return function (t) {
            var d2 = interpolate(t)
            return midAngle(d2) < Math.PI ? 'end' : 'start'
          }
        })

      text2.exit().remove()
    }

    /* ------- TEXT LABELS -------*/
    var text = this.svg
      .select('.labels')
      .selectAll('text')
      .data(this.pie(data.chartData), key)

    text
      .enter()
      .append('text')
      .attr('dy', '50px')
      .attr('fill', '#000')
      .attr('font-family', 'GT-America-Thin')
      .attr('font-size', '25px')
      .attr('class', 'text1')
      .text(function (d) {
        return d.data.label
      })

    text
      .transition()
      .duration(1000)
      .text(function (d, i) {
        return d.data.label
      })
      .attrTween('transform', function (d) {
        this._current = this._current || d
        var interpolate = d3.interpolate(this._current, d)
        this._current = interpolate(0)
        return function (t) {
          var d2 = interpolate(t)
          var pos = that.outerArc.centroid(d2)
          pos[0] = (that.width / 2) * (midAngle(d2) < Math.PI ? 1 : -1)
          return 'translate(' + pos + ')'
        }
      })
      .styleTween('text-anchor', function (d) {
        this._current = this._current || d
        var interpolate = d3.interpolate(this._current, d)
        this._current = interpolate(0)
        return function (t) {
          var d2 = interpolate(t)
          return midAngle(d2) < Math.PI ? 'end' : 'start'
        }
      })

    // text
    //   .select('.values')
    //   .append('svg:image')
    //   .attr('xlink:href', VestibularIcon)
    //   .attr('width', 40)
    //   .attr('height', 40)

    text.exit().remove()

    /* ------- VALUES -------*/
    var text3 = this.svg
      .select('.values')
      .selectAll('text')
      .data(this.pie(data.chartData), key)

    var total = d3.sum(data.chartData, function (d) {
      return d.value
    })

    text3
      .enter()
      .append('text')
      .attr('dy', '-45px')
      .attr('fill', '#000')
      .attr('font-family', 'GT-America-Thin')
      .attr('font-size', '50px')
      .attr('class', 'text3')

    function midAngle(d) {
      return d.startAngle + (d.endAngle - d.startAngle) / 2
    }

    text3
      .transition()
      .duration(1000)
      .text(function (d, i) {
        return d3.round((100 * d.data.value) / total, 2) + '% '
      })
      .attrTween('transform', function (d) {
        this._current = this._current || d
        var interpolate = d3.interpolate(this._current, d)
        this._current = interpolate(0)
        return function (t) {
          var d2 = interpolate(t)
          var pos = that.outerArc.centroid(d2)
          pos[0] = midAngle(d2) < Math.PI ? that.width / 2 : -that.width / 2
          return 'translate(' + pos + ')'
        }
      })
      .styleTween('text-anchor', function (d) {
        this._current = this._current || d
        var interpolate = d3.interpolate(this._current, d)
        this._current = interpolate(0)
        return function (t) {
          var d2 = interpolate(t)
          return midAngle(d2) < Math.PI ? 'end' : 'start'
        }
      })

    text3.exit().remove()

    /* ------- END LEGENDS AND VALUES -------*/

    /* ------- SLICE TO TEXT POLYLINES -------*/

    var polyline = this.svg
      .select('.lines')
      .selectAll('polyline')
      .data(this.pie(data.chartData), key)

    polyline
      .enter()
      .append('polyline')
      .style('stroke', 'black')
      .style('stroke-width', '2')
      .style('opacity', '1')

    polyline
      .transition()
      .duration(1000)
      .attrTween('points', function (d) {
        this._current = this._current || d
        var interpolate = d3.interpolate(this._current, d)
        this._current = interpolate(0)
        return function (t) {
          var d2 = interpolate(t)
          var pos = that.outerArc.centroid(d2)
          pos[0] = (that.width / 2) * (midAngle(d2) < Math.PI ? 1 : -1)
          return [that.arc.centroid(d2), that.outerArc.centroid(d2), pos]
        }
      })

    polyline.exit().remove()

    /* ------- BLACK CIRCLES -------*/
    var blackCircle = this.svg
      .select('.circles')
      .selectAll('circle')
      .data(this.pie(data.chartData), key)
      .moveToFront()

    blackCircle
      .enter()
      .append('circle')
      .attr('r', '9px')
      .style('stroke', 'black')
      .style('stroke-width', '3')
      .style('fill', 'fff')

    blackCircle
      .transition()
      .duration(1000)
      .attrTween('transform', function (d) {
        this._current = this._current || d
        var interpolate = d3.interpolate(this._current, d)
        this._current = interpolate(0)
        return function (t) {
          var d2 = interpolate(t)
          var pos = that.outerArc.centroid(d2)
          pos[0] = that.radius * 0.95 * (midAngle(d2) < Math.PI ? 1 : -1)
          return 'translate(' + that.arc.centroid(d2) + ')'
        }
      })

    blackCircle.exit().remove()
  }

  this.randomValues = function () {
    var newData = {
      centerValue: {
        value: Math.round(Math.random() * 50, 0),
        label: 'MET-min/work week'
      },
      chartData: [
        {
          legend: 'Walking',
          value: Math.round(Math.random() * 50, 2),
          label: Math.round(Math.random() * 1000, 0) + ' MET-min/week',
          icon: this.path + 'vestibular.svg'
        },
        {
          legend: 'Vigorous',
          value: Math.round(Math.random() * 50, 2),
          label: Math.round(Math.random() * 1000, 0) + ' MET-min/week',
          icon: this.path + 'proprioceptive.svg'
        },
        {
          legend: 'Moderate',
          value: Math.round(Math.random() * 50, 2),
          label: Math.round(Math.random() * 1000, 0) + ' MET-min/week',
          icon: this.path + 'visual.svg'
        }
      ]
    }
    this.update(newData)
  }
}

d3.selection.prototype.moveToFront = function () {
  return this.each(function () {
    this.parentNode.appendChild(this)
  })
}

d3.selection.prototype.moveToBack = function () {
  return this.each(function () {
    var firstChild = this.parentNode.firstChild
    if (firstChild) {
      this.parentNode.insertBefore(this, firstChild)
    }
  })
}
